import { render, staticRenderFns } from "./SearchDictItemSelect.vue?vue&type=template&id=4b9b32d1"
import script from "./SearchDictItemSelect.vue?vue&type=script&lang=js"
export * from "./SearchDictItemSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports